import Swiper, { FreeMode, Mousewheel, Scrollbar } from 'swiper';

const swiper = new Swiper('.bestsellers-section .swiper', {
  // Optional parameters
  modules: [FreeMode, Mousewheel, Scrollbar],
  spaceBetween: 12,
  slidesPerView: 1.55,
  mousewheel: {
    forceToAxis: true,
  },
  freeMode: true,
  scrollbar: {
    el: '.swiper-scrollbar',
    dragSize: 95,
    draggable: true,
  },
  breakpoints: {
    576: {
      spaceBetween: 16,
      slidesPerView: 3.5,
      scrollbar: {
        dragSize: 200
      }
    },
    1280: {
      slidesPerView: 3.5,
      spaceBetween: 20,
      scrollbar: {
        dragSize: 280
      }
    },
  },
  // And if we need scrollbar
  // scrollbar: {
  //   el: '.swiper-scrollbar',
  // },
});
